export function greet(name) {
  return `Hello, ${name}! This app has source maps enabled.`;
}
